import { Injectable } from '@angular/core';
import { LayoutActionTypes } from '@app/core/ngrx/actions';
import { concat, of } from 'rxjs';
import { flatMap } from 'rxjs/operators';
import { Actions, ofType, createEffect } from '@ngrx/effects';

/**
 * LayoutEpics
 */
@Injectable()
export class LayoutEffects {
  constructor(private actions$: Actions) {}
  /**
   * onNavigation
   * @param {ActionsObservable<any>} action$
   * @returns {Observable<any>}
   */
  onNavigation = createEffect(() =>
    this.actions$.pipe(
      ofType('UPDATE_LOCATION'),
      flatMap(() => concat(of({ type: LayoutActionTypes.CLOSE_SIDENAV }))),
    ),
  );
}
